import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/aDdcWDbHm6RWitJ52uydMB/carrusel_1.webp',
    alt: 'Receta Ancestral 1'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/n5NFywkvJ4HjkRNqHLt8FC/carrusel_2.webp',
    alt: 'Receta Ancestral 2'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pMSotZbPTXDyWtkGEWxyVK/carrusel_3.webp',
    alt: 'Receta Ancestral 3'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4PJ52LbZ8AB9aiVA9x5TCA/carrusel_4.webp',
    alt: 'Receta Ancestral 4'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/3uvcXXTpHZXaFocVoQMDS4/carrusel_5.webp',
    alt: 'Receta Ancestral 5'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/fDZePD7dDf4NNnihuMpQSf/carrusel_6.webp',
    alt: 'Receta Ancestral 6'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/fqbcCYugVcioFTX9ezbRVr/carrusel_7.webp',
    alt: 'Receta Ancestral 7'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mUD8zB7TZ1wpWGo9os7dqX/carrusel_8.webp',
    alt: 'Receta Ancestral 8'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/565T3fbewY3uJGaXuKzzVq/carrusel_9.webp',
    alt: 'Receta Ancestral 9'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2RiiouPu8Tdp67zAQz6LfH/carrusel_10.webp',
    alt: 'Receta Ancestral 10'
  }];
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-[#0f1711]/5 pt-[30px] pb-[30px]" data-id="element-258">
      <style data-id="element-259">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-4 text-center mb-12" data-id="element-260">
        <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-[#1E1B1B]" data-id="element-261">
          RECETAS QUE <span className="text-[#8b7355]" data-id="element-262">VAS A DOMINAR</span>
        </h2>
        <p className="text-xl text-[#3e2723]/70 max-w-2xl mx-auto font-medium font-serif italic" data-id="element-263">
          Desde fermentos básicos hasta platos complejos de sanación profunda.
          Vuelve a lo esencial.
        </p>
      </div>

      <div className="relative w-full overflow-hidden py-10" data-id="element-264">
        <div className="flex w-max animate-scroll gap-8 px-4" data-id="element-265">
          {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-[450px] h-64 md:h-80 shrink-0 transition-all duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-266">
              <motion.div className="relative w-full h-full rounded-[2rem] overflow-hidden border border-[#0f1711]/10 group-hover:border-[#8b7355]/50 transition-all duration-500" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} data-id="element-267">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" data-id="element-268" />
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}